export const REDACTED = '[REDACTED]'

// Query parameter names that carry sensitive values (OAuth codes, reset tokens,
// PII). `x-amz-*` covers a presigned S3 url, which is a write credential until
// it expires; the whole family is redacted so a new signing param cannot leak.
// `x-goog-*`, `signature`, `sig` and `jwt` are the same grant on GCS,
// CloudFront and Linear uploads, Azure SAS, and GitHub private images.
// USERINFO is MuniPOINTS' auth token, passed as a query parameter.
// custodian_account_id is a client's account number at their custodian;
// `order_account` carries the same on marketplace order links.
const SENSITIVE_QUERY_PARAMS =
  /^(code|token|auth_jwt|refreshToken|x-amz-.+|x-goog-.+|signature|sig|jwt|USERINFO|custodian_account_id|custodianAccountId|custodian-account-id|order_account)$/i

/** Shared by every recorder we send urls to; a credential is a credential
 *  whichever one is looking. */
export function sanitizeUrl(url: string): string {
  try {
    const parsed = new URL(url)
    for (const key of [...parsed.searchParams.keys()]) {
      if (SENSITIVE_QUERY_PARAMS.test(key)) {
        parsed.searchParams.set(key, REDACTED)
      }
    }
    return parsed.toString()
  } catch {
    return url
  }
}

const URL_IN_TEXT = /https?:\/\/[^\s"'`<>]+/g

/** Error messages quote the url that failed (pdf.js, fetch), so a presigned
 *  url reaches free text as well as the request fields. */
export function sanitizeUrlsInText(text: string): string {
  return text.replace(URL_IN_TEXT, (url) => sanitizeUrl(url))
}
